// extracted by mini-css-extract-plugin
export default {"banner":"style_banner__uqSb1","banner__text":"style_banner__text__-zEcz","fadeInOut":"style_fadeInOut__wDsnD"};